import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import TextLink from "@shared/v2/TextLink";
import Typography from "@shared/v2/Typography";
import { useEffect, useState } from "react";

const ImageSizeErrorModal = () => {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => setShowModal((s) => !s);

  useEffect(() => {
    const onToggleModal = () => setShowModal((s) => !s);
    document.addEventListener("account:imageSizeError", onToggleModal);
    return () => {
      document.removeEventListener("account:imageSizeError", onToggleModal);
    };
  }, []);

  return (
    <Modal
      containerClassName="!tw-z-3000"
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[440px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
      show={showModal}
      onHide={toggleModal}
    >
      <Modal.Header title="This image is too big!" closeButton />
      <Modal.Body>
        <Typography variant="body-m">
          Image files must be smaller than 5MB.{" "}
          <TextLink
            href="https://www.brivityknowledge.com/docs/images-in-email-signature-or-email-templates?highlight=email%20signature"
            target="_blank"
          >
            Learn more about how to upload images to your email signature.
          </TextLink>
        </Typography>
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-end">
        <Button size="medium" onClick={toggleModal}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImageSizeErrorModal;
